let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iuMRi")).then(() => parcelRequire('4NPdN'));